import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, glyphs, useMediaQuery } from "../../../Styles";
import { NewInput, NewSelect, CheckBox, CheckStyles } from "../..";
import { DataObj, labelToKeyMap, Params } from "../../../Definitions/valueTypes";

// TODO
import { ReportData } from "../../../Definitions/valueTypes";

interface Lvl1_Props {
  reportData?: ReportData
  onReportDataChange: (data: ReportData) => void
}

export default function ReportModalLvl1({ reportData, onReportDataChange}:Lvl1_Props) {
  const {t} = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 805px)`);
  
  // Archive Options
  const archiveOptions = [    
    { label: t("no", {defaultValue: "no"}), id: 0 },
    { label: t("yes", {defaultValue: "yes"}), id: 1 },
  ]

  // Report Data
  const _reportData = useMemo(() => {
    const reportName = reportData && reportData.name ? reportData.name : undefined
    const reportArchived = reportData && reportData.archived === true ? archiveOptions[1] : archiveOptions[0]
    
    const startDate = reportData && reportData.startDate ? reportData.startDate : Date.now()
    const endDate = reportData && reportData.endDate ? reportData.endDate : Date.now()

    return {
      reportName,
      reportArchived,
      startDate,
      endDate
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportData])

  // Data Levels
  const dataLevels = useMemo(() => {
    const _dataLevels: Params[] = [
      "animalId",
      "animalGroupId",
      "systemId"
    ] as Params[]

    return _dataLevels.map((param, index) => {
      const label = Object.entries(labelToKeyMap).find(([_, key]) => key === (param as any))?.[0];
      
      return (
        <CheckBox 
          key={index} 
          text={t(`params.${label}`, {defaultValue: `${label}`})}
          checkStyle={CheckStyles.blue} 
          isChecked={reportData && reportData.dataLevel === param as unknown as DataObj}
          onChange={() => onReportDataChange({ ...reportData, reportId: reportData?.reportId || 0, dataLevel: param as unknown as DataObj })}
        />
      )
    })

  }, [onReportDataChange, reportData, t])

  return (
    <div style={{display: "flex", flexDirection: "column", gap: "40px"}}>
      <div style={{display: "grid", gap: "10px 30px", margin: "0 auto", gridTemplateColumns: mobileXs ? "1fr" : "repeat(2, 1fr)", gridTemplateRows: mobileXs ? "1fr" : "1fr 1fr"}}>
        <div style={{gridArea: "1/1/2/2"}}>
          <NewInput
            header={t("reportPages.reports.reportName", {defaultValue: "Report Name"})}
            onChange={(value) => onReportDataChange({...reportData, reportId: reportData?.reportId || 0, name: value})}
            valueOverrides={{ defaultValue: _reportData.reportName }}
            isRequired
            isClearable
          />      
        </div>
        <div style={{gridArea: "2/1/3/2"}}>
          <NewSelect
            header={t("reportPages.reports.archiveReport", { defaultValue: "Archive Report" })}
            options={archiveOptions}
            onChange={(selectedOption) => { if (selectedOption) { onReportDataChange({ ...reportData, reportId: reportData?.reportId || 0, archived: selectedOption.id === 1 }) } }}
            valueOverrides={{ defaultValue: _reportData.reportArchived }}
          />
        </div>
        <div style={{ gridArea: mobileXs ? "3/1/4/2" : "1/2/2/3" }}>
          <NewInput
            header={t("reportPages.reports.startDate", {defaultValue: "start date"})}
            valueOverrides={{ valueType: 'date'}}
            onChange={(e) => onReportDataChange({...reportData, reportId: reportData?.reportId || 0, startDate: new Date(e).getTime()})} // TODO: When db is implemented, remember to divide by 1000 (see basicInfo -> birthDate)
            startEnhancer={glyphs.Calendar({})}
            isRequired
            isClearable
          />
        </div>
        <div style={{ gridArea: mobileXs ? "4/1/5/2" : "2/2/3/3" }}>
          <NewInput
            header={t("reportPages.reports.endDate", {defaultValue: "end date"})}
            valueOverrides={{ valueType: 'date'}}
            onChange={(e) => onReportDataChange({ ...reportData, reportId: reportData?.reportId || 0, endDate: new Date(e).getTime() })}  // TODO: When db is implemented, remember to divide by 1000 (see basicInfo -> birthDate)
            startEnhancer={glyphs.Calendar({})}
            isRequired
            isClearable
          />
        </div>
      </div>
      <div style={{width: mobileXs ? "100%" : "590px", margin: "0 auto", boxSizing: "border-box"}}>
        <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary, padding: "0px 0px 2px 10px" }}>{t("reportPages.reports.dataLevel", { defaultValue: "data level" })}</p>
        <div style={{height: "2px", width: mobileXs ? "100%" : "280px", backgroundColor: colors.blueDarkSecondary}}/>
        <div style={{paddingTop: "10px", maxHeight: "200px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ width: "fit-content", display: "grid", gridTemplateColumns: mobileXs ? "1fr 1fr" : "1fr 1fr 1fr", gridTemplateRows: mobileXs ? "1fr 1fr" : "", columnGap: mobileXs ? "50px" : "100px", rowGap: "10px" }}>
            {dataLevels}
          </div>
        </div>
      </div>
    </div>
  )
}